import { type Tag } from '@@api/services/metadata/schemas';
import { type Category, type Tenant } from '@@api/services/tenant/schemas';
import { convertToNumber } from '@@scripts/utils/idUtils';

export const COLUMN_TYPE = {
    CATEGORY: 'c',
    TAG: 't',
} as const;

export type ColumnType = (typeof COLUMN_TYPE)[keyof typeof COLUMN_TYPE];

export type PlacementColumn = string;

const SEPARATOR = '_';

export const PLACEHOLDER_ID = `0${SEPARATOR}0`;

export const serializeCategoryColumnId = (tenantId: Tenant['id'], categoryId: Category['id']) =>
    `${COLUMN_TYPE.CATEGORY}${tenantId}${SEPARATOR}${categoryId}`;

export const serializeTagColumnId = (tenantId: Tenant['id'], tagId: Tag['id']) =>
    `${COLUMN_TYPE.TAG}${tenantId}${SEPARATOR}${tagId}`;

export const deserializeColumnId = (columnId: PlacementColumn): [ColumnType, PlacementColumn] => {
    const columnType = columnId[0] as ColumnType;
    const id = columnId.slice(1);

    return [columnType, id];
};

export const deserializeColumnTypeId = (
    columnId: PlacementColumn,
): [Tenant['id'], Category['id'] | Tag['id']] => {
    const id = deserializeColumnId(columnId)[1];

    const [tenantId, pageTypeId] = id.split(SEPARATOR).map(convertToNumber);

    return [tenantId, pageTypeId];
};
